module.exports = __webpack_public_path__ + "media/images/miscellaneous_icons/back-arrow-b8cdfe23614ab5aeaa62be410664cc75.png";